import NiceModal from "@ebay/nice-modal-react";
import { requester } from "App";
import Dummy from "components/Dummy";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import DatePicker from "components/inputs/datePicker/DatePicker";
import InputText from "components/inputs/signUp/InputText";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import style from "./TrackOrder.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";


function TrackOrder() {
    const { userName } = useContext(AuthContext);
    const { isMobile } = useContext(BrowserDetectContext);
    const [isMounted, setMounted] = useState(false);
    const [purchaseOrder, setPurchaseOrder] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(3);
    const searchRef = useRef();
    const dateRef = useRef();
    const [selectValue, setSelectValue] = useState('productName');

    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        if (isMounted) {
            let data = {};
            requester.findAllPurchaseOrder(data, (result) => {
                if (result.code === 0) {
                    
                    const sortedData = result.data.sort((a, b) => {
                        return new Date(b.createDateTime) - new Date(a.createDateTime);
                    });
                    setPurchaseOrder(sortedData);
                }

            });
        }
    }, [isMounted]);

    // 현재 페이지의 아이템을 가져오는 함수
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = purchaseOrder && purchaseOrder.slice(indexOfFirstItem, indexOfLastItem);

    // 페이지를 변경하는 함수
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // 페이지네이션 컴포넌트 (여기에 스타일을 적용하거나 별도의 컴포넌트로 분리할 수 있습니다.)
    const PageNumbers = () => {
        const pageCount = Math.ceil(purchaseOrder?.length / itemsPerPage);
        let startPage, endPage;
        const pageNumbers = [];

        if (pageCount <= 5) {
            // 전체 페이지 수가 5 이하면 모든 페이지 번호를 보여줍니다.
            startPage = 1;
            endPage = pageCount;
        } else {
            // 현재 페이지가 3보다 크면 시작 페이지 번호를 현재 페이지 번호 - 2로 설정
            // 그렇지 않으면 시작 페이지 번호를 1로 설정
            if (currentPage > 3) {
                startPage = currentPage - 2;
                // 현재 페이지 + 2가 전체 페이지 수보다 크면, 
                // 끝 페이지를 전체 페이지 수로 설정
                if (currentPage + 2 > pageCount) {
                    endPage = pageCount;
                    startPage = pageCount - 4;
                } else {
                    endPage = currentPage + 2;
                }
            } else {
                startPage = 1;
                endPage = 5;
            }
        }

        // 설정된 시작과 끝 페이지 번호에 따라 페이지 번호 배열 생성
        for (let number = startPage; number <= endPage; number++) {
            pageNumbers.push(number);
        }

        return (
            <nav>
                <ul className={style.paginationContainer}>
                    {pageNumbers.map(number => (
                        <li key={number} className={style.pageItem}>
                            <p
                                onClick={() => paginate(number)}
                                className={`${style.pageLink} ${currentPage === number ? style.currentPage : ''}`}
                            >
                                {number}
                            </p>
                        </li>
                    ))}
                </ul>
            </nav>
        );
    };

    const removeDuplicates = (data) => {
        const uniqueById = new Map(data.map(item => [item.id, item]));
        
        return Array.from(uniqueById.values());
    }

    const search = () => {
        let data = {
            productName: '',
            startDate: '',
            endDate: ''
        }

        if (selectValue === 'none') {
            toast.error("검색 방법을 선택하세요", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
        } else if (selectValue === 'productName') {
            if (searchRef.current.getValue().length > 0) {
                data.productName = searchRef.current.getValue();
                requester.searchByProductName(data, (result) => {
                    setPurchaseOrder(removeDuplicates(result.data));
                })
                
            } else {
                toast.error("검색어를 입력하세요", {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }




        } else {
            data.startDate = dateRef.current.getStartDate();
            data.endDate = dateRef.current.getEndDate();
            requester.searchByDateTime(data, (result) => {
                
            })
            
        }

    }
    const onSelectChange = (e) => {
        setSelectValue(e.target.value);

    }
    const onOrderDetailClick = (data) => {
        NiceModal.show("purchaseOrder", { data: data })
    }
    useEffect(() => {
        
    }, [selectValue])

    return (
        <Container maxWidth={1200}>
            <Dummy height={"30px"} />
            <VerticalFlex gap={10}>
                {
                    isMobile &&
                    <FlexChild>
                        <P size={25} color={"black"} weight={"bold"}>구입내역</P>
                    </FlexChild>

                }
                <FlexChild width={"90%"} justifyContent={"center"}>
                    {
                        selectValue === 'dateTime'
                            ?
                            <DatePicker ref={dateRef} />
                            :
                            <HorizontalFlex justifyContent={"center"}>
                                <FlexChild>
                                    <InputText ref={searchRef} onEnterPress={search} />
                                </FlexChild>
                                <FlexChild width={50}>
                                    <div className={style.icon} onClick={search}>
                                        <Center>
                                            <FontAwesomeIcon icon={fas["faSearch"]} />
                                        </Center>
                                    </div>
                                </FlexChild>
                            </HorizontalFlex>

                    }
                </FlexChild>
                {
                    currentItems &&
                    currentItems.map((data, index) => {
                        const [datePart, timePart] = data.createDateTime.split('T');
                        const [year, month, day] = datePart.split('-');
                        const [hours, minutes] = timePart.split(':');
                        const date = new Date(year, month - 1, day, hours, minutes);
                        const formattedDate = `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일 ${date.getHours()}시${date.getMinutes()}분`;

                        return (
                            <>

                                {
                                    data.orderProducts.length > 1
                                        ?
                                        <FlexChild width={"95%"} >
                                            <div className={style.purchaseOrderWrap}>
                                                <HorizontalFlex gap={20}>
                                                    <FlexChild width={"initial"} padding={5}>
                                                        <img src={data.orderProducts[0].productImg} width={"100px"} />
                                                    </FlexChild>
                                                    <FlexChild>
                                                        <VerticalFlex>
                                                            <FlexChild>
                                                                <P>구입날짜</P>
                                                            </FlexChild>
                                                            <FlexChild>
                                                                <P>{formattedDate}</P>
                                                            </FlexChild>
                                                        </VerticalFlex>
                                                    </FlexChild>
                                                    <FlexChild>
                                                        <Center width={"100%"} textAlign={"left"}>
                                                            <P>{data.orderProducts[0].productName} 외 {data.orderProducts.length - 1}개 </P>
                                                        </Center>
                                                    </FlexChild>
                                                    <FlexChild>
                                                        <Center width={"100%"}>
                                                            <P cursor onClick={() => onOrderDetailClick(data)}>상세보기 </P>
                                                        </Center>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </div>
                                        </FlexChild>

                                        :
                                        <FlexChild width={"95%"}  >
                                            <div className={style.purchaseOrderWrap}>
                                                <HorizontalFlex gap={20}>
                                                    <FlexChild width={"initial"} padding={5}>
                                                        <img src={data.orderProducts[0].productImg} width={"100px"} />
                                                    </FlexChild>
                                                    <FlexChild>
                                                        <VerticalFlex>
                                                            <FlexChild>
                                                                <P>구입날짜</P>
                                                            </FlexChild>
                                                            <FlexChild>
                                                                <P>{formattedDate}</P>
                                                            </FlexChild>
                                                        </VerticalFlex>
                                                    </FlexChild>
                                                    <FlexChild>
                                                        <Center width={"100%"} textAlign={"left"}>
                                                            <P>{data.orderProducts[0].productName} </P>
                                                        </Center>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </div>

                                        </FlexChild>

                                }



                            </>
                        );
                    })
                }
                <FlexChild alignItems={"center"}>
                    <PageNumbers />
                </FlexChild>
            </VerticalFlex>


        </Container>
    );
}

export default TrackOrder;